import React, { Component } from 'react'
import { GlobalSection, GlobalContainer } from "../components/GlobalStyle"
import GoogleMapReact from 'google-map-react'
import styled from 'styled-components'
import marker from '../images/map-marker.png'
import { withTranslation } from 'react-i18next';

const StyledMapMarker = styled.div`
  height: 120px;
  width: 120px;
  background-image: url(${marker});
  background-size: contain;
  position: relative;
  top: -110px;
  left: -60px;
);
`
const StyledMapWrap = styled.div`
  height: 800px;
  width: 100%;
  position: relative;
  top: -100px;
  @media (max-width: 1000px) {
    display: flex;
    flex-direction: column;
  }
`
const StyledMapContactOpacity = styled.div`
  opacity: .5;
`
const StyledMapContactBox = styled.div`
  background-color: #fff;
  text-align: center;
  padding: 20px;
  height: 550px;
  width: 400px;
  position: absolute;
  top: 50%;
  right: 150px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 1000px) {
    display: flex;
    flex-direction: column;
    position: static;
    width: 95%;
    margin: 0 auto;
    transform: translateY(-50px);
    box-shadow: 0 2px 12px 0 rgba(12,0,46,0.08);
  }
`
const StyledMapContactTitle = styled.a`
  div {
    font-size: 1.4em;
    font-weight: bold;
    color: var(--main);
  }
  span {
    font-size: .9em;
    opacity: .6;
    color: #000;
  }
`
class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      center: {
        lat: 54.436194,
        lng: 18.5916690
      }};
  }
  componentDidMount() {
    this.setState({
      center: {
        lat: window.innerWidth > 1000 ? 54.436194 : 54.4300189,
        lng: window.innerWidth > 1000 ? 18.591669 : 18.5623858
    }})
  }

  static defaultProps = {
    zoom: 14,
    styles: [
      {
        "featureType": "all",
        "stylers": [
          {
            "saturation": 0
          },
          {
            "hue": "#999"
          }
        ]
      },
      {
        "featureType": "road",
        "stylers": [
          {
            "saturation": -70
          }
        ]
      },
      {
        "featureType": "transit",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "water",
        "stylers": [
          {
            "visibility": "simplified"
          },
          {
            "saturation": -60
          }
        ]
      }
    ]
  };

  render() {
    return (
      <GlobalSection bg="#fff" noPadding>
        <GlobalContainer>
          <StyledMapWrap>
            <GoogleMapReact
              bootstrapURLKeys={{ key: 'AIzaSyCVx2OgLFT5uT4ghBhFMIuXUBmQqOEWq84' }}
              options={this.props}
              defaultZoom={this.props.zoom}
              //defaultCenter={this.props.center}
              defaultCenter={
              this.state.center
              }
            >
              <StyledMapMarker
                lat={54.4300189}
                lng={18.5612858}
              />
            </GoogleMapReact>
            <StyledMapContactBox>
              <div>
							{this.props.t('map.location')}
              </div>
              <StyledMapContactTitle>
                <div>Sopot Wyścigi</div>
                <span>{this.props.t('map.text1')}</span>
              </StyledMapContactTitle>
              <div>
                Leśna 1
              </div>
              <div>
                81-876 Sopot
              </div>
              <StyledMapContactOpacity>
							{this.props.t('map.text2')}
                <br />
                  9:00 - 18:00
              </StyledMapContactOpacity>
              <br></br>
              <StyledMapContactTitle href="tel:+48603113673">
              603 113 673
              </StyledMapContactTitle>
              <StyledMapContactTitle href="mailto: biuro@lesnahub.pl">
                biuro@lesnahub.pl
              </StyledMapContactTitle>
            </StyledMapContactBox>
          </StyledMapWrap>
        </GlobalContainer>
      </GlobalSection>
    );
  }
}

export default withTranslation()(Map);
